export default __webpack_public_path__ + "static/media/lighthouse-bg.cc039dfb.png";